//@flow
import firebase from 'firebase/app';
import 'firebase/functions';

export type UserRole = 'admin' | 'customer';
export type AccountType = 'basic' | 'pro' | 'business';
export type User = {
  displayName: string,
  email: string,
  photoUrl?: string,
  accountType: AccountType,
};

export type ClubFields = {
  name?: string,
  phone?: string,
  email?: string,
  dob?: string,
};

export async function createUser(user: User): { data?: User, error?: string } {
  const func = firebase.functions().httpsCallable('createUser');
  return func({
    email: user.email,
    displayName: user.displayName,
    organizationId: user.organizationId,
  });
}

export async function sendClubEmail(fields: ClubFields): {error?: string } {
  const func = firebase.functions().httpsCallable('sendClubEmail');
  return func({
    name: fields.name,
    phone: fields.phone,
    email: fields.email,
    dob: fields.dob,
  });
}
